module.exports = __webpack_public_path__ + "static/media/denny_ilyas.66bbd6e6.jpg";